import useSoundVendor from 'use-sound';
import { useRecoilValue } from 'recoil';

import { controlsAtom } from 'store';

import btnEnable from 'assets/sounds/button_enable.mp3';
import btnHover from 'assets/sounds/button_hover.mp3';
import goldReveal from 'assets/sounds/gold_reveal.mp3';
import mainTheme from 'assets/sounds/main_theme.mp3';
import stoneClick from 'assets/sounds/stone_click.mp3';
import stoneHover from 'assets/sounds/stone_hover.mp3';
import stoneShake from 'assets/sounds/stone_shake.mp3';
import dynamiteExplosion from 'assets/sounds/dynamite_explosion.mp3';
import gameStarter from 'assets/sounds/game_starter.mp3';
import fallingStones from 'assets/sounds/falling_stones.mp3';
import successfulGame from 'assets/sounds/win.mp3';
import characterLose from 'assets/sounds/character_lose.mp3';
import characterWin1 from 'assets/sounds/character_win_1.mp3';
import characterWin2 from 'assets/sounds/character_win_2.mp3';
import characterWin3 from 'assets/sounds/character_win_3.mp3';
import characterNod from 'assets/sounds/character_nod.mp3';

type TSoundName =
  | 'btnEnable'
  | 'btnHover'
  | 'goldReveal'
  | 'mainTheme'
  | 'stoneClick'
  | 'stoneHover'
  | 'stoneShake'
  | 'dynamiteExplosion'
  | 'gameStarter'
  | 'fallingStones'
  | 'successfulGame'
  | 'characterLose'
  | 'characterWin1'
  | 'characterWin2'
  | 'characterWin3'
  | 'characterNod'
  | 'NOT_SOUND';

const soundMap: {
  [key in TSoundName]: string;
} = {
  btnEnable,
  btnHover,
  goldReveal,
  mainTheme,
  stoneClick,
  stoneHover,
  stoneShake,
  dynamiteExplosion,
  gameStarter,
  fallingStones,
  successfulGame,
  characterLose,
  characterWin1,
  characterWin2,
  characterWin3,
  characterNod,
  NOT_SOUND: '',
};

export const useSound = (
  name: TSoundName,
  options?: {
    [key: string]: string | boolean | number;
  },
) => {
  const controls = useRecoilValue(controlsAtom);

  return useSoundVendor(soundMap[name], {
    soundEnabled: controls.sound,
    volume: 0.6,
    ...options,
  });
};
